import { DEFAULT_LAN } from "config/constants";

/** Coerce language query params so we never send literal "undefined" / "null" to the API. */
export function normalizeApiLanguageCode(raw: unknown): string {
  if (raw == null) return DEFAULT_LAN;
  const s = String(raw);
  if (s === "" || s === "undefined" || s === "null") return DEFAULT_LAN;
  const trimmed = s.trim();
  return trimmed === "" ? DEFAULT_LAN : trimmed;
}
